import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dataset, DatasetSubtype } from '../store/models';
import { BasicDocumentReader } from '../store/models/basic-document-reader';

@Injectable({
  providedIn: 'root'
})
export class DocumentDisplayNameService {

  constructor(
    private translateService : TranslateService,
  ) { }

  public getDisplayName(dataset: Dataset, docReader: BasicDocumentReader): string {
    let documentName: string;
    switch (dataset?.subtype) {
      case DatasetSubtype.Facility:
        documentName = docReader.name;
        break;
      case DatasetSubtype.Person:
      case DatasetSubtype.HorizonPerson:
      case DatasetSubtype.Assignment:
      case DatasetSubtype.SamsaraDriver:
        documentName =
          docReader.getFieldValue('display_name') ||
          docReader.name ||
          this.getFirstAndLastName(docReader) ||
          docReader.getFieldValue('employee_id');
        break;
      case DatasetSubtype.Shipment:
        documentName = 
          docReader.getFieldValue('shipment_id') || 
          docReader.getFieldValue('tracking_number');
        break;
      case DatasetSubtype.Transports:
        documentName = 
          docReader.getFieldValue('tems_id') || 
          docReader.getFieldValue('name');
        break;
      case DatasetSubtype.TravelItinerary:
        documentName =
          docReader.getFieldValue('display_name') ||
          docReader.name ||
          this.getFirstAndLastName(docReader) ||
          docReader.getFieldValue('itinerary_locator');
        break;
      case DatasetSubtype.Flight:
        documentName =
          docReader.getFieldValue('flight_number') ||
          docReader.name ||
          docReader.getFieldValue('registration') ||
          docReader.getFieldValue('aircraft_id');
        break;
      case DatasetSubtype.Vehicle:
        documentName =
          docReader.name ||
          docReader.getFieldValue('vin') ||
          docReader.getFieldValue('driver_name');
        break;
      case DatasetSubtype.Job:
        documentName =
          docReader.name ||
          docReader.getFieldValue('job_number') ||
          docReader.getFieldValue('job_id');
        break;
      case DatasetSubtype.Schedule:
        documentName =
          docReader.name ||
          docReader.getFieldValue('schedule_id') ||
          docReader.getFieldValue('job_number') ||
          docReader.getFieldValue('job_id');
        break;
      default:
        documentName =
          docReader.getFieldValue('display_name') ||
          docReader.name;
        break;
    }

    if (!documentName) {
      documentName = this.translateService.instant('MAP.NO-NAME-FOUND');
    }

    if (documentName?.length > 150) {
      // Trim long fields
      documentName = documentName.slice(0, 150);
    }

    return documentName;
  }

  private getFirstAndLastName(docReader: BasicDocumentReader): string {
    let documentName: string;
    const first = docReader.getFieldValue('first_name') || docReader.getFieldValue('first');
    const last = docReader.getFieldValue('last_name') || docReader.getFieldValue('last');
    if (first && last) {
      documentName = first + ' ' + last;
    } else if (first) {
      documentName = first;
    } else if (last) {
      documentName = last;
    }

    return documentName;
  }  
}
